<template>
    <div>
        <h2 class="sma-title-about sma-title-blog font-balo" v-if="blog">
            {{ blog.title ? blog.title : $t("app.Featured Blogs") }}
        </h2>
        <div class="top-blog row">
            <div class="bg-big-blog col-md-7" v-if="mainPost">
                <div class="big-blog">
                    <div
                        class="feature-blog"
                        :style="{ backgroundImage: `url(${mainPost.image})` }"
                    >
                        <router-link :to="`/blog/${mainPost.ID}`"></router-link>
                    </div>
                    <div class="description-blog">
                        <h3>
                            <router-link :to="`/blog/${mainPost.ID}`">{{
                                mainPost.title
                            }}</router-link>
                        </h3>
                        <p v-html="mainPost.content"></p>
                        <div class="time-post" v-if="mainPost.date">
                            {{ mainPost.date }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-top-blog col-md-5" v-if="posts.length > 0">
                <div
                    class="it-top-blog"
                    v-for="(post, index) in posts"
                    :key="index"
                >
                    <div
                        class="feature-blog"
                        :style="{ backgroundImage: `url(${post.image})` }"
                    >
                        <router-link :to="`/blog/${post.ID}`"></router-link>
                    </div>
                    <div class="description-blog">
                        <h3>
                            <router-link :to="`/blog/${post.ID}`">{{
                                post.title
                            }}</router-link>
                        </h3>
                        <div class="time-post" v-if="post.date">
                            {{ post.date }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { find, first, filter } from "lodash";
export default {
    name: "FeaturedBlog",
    data() {
        return {
            mainPost: null,
            posts: []
        };
    },
    computed: {
        ...mapState({
            blog: state =>
                find(state.blogs.list, item => item.name === "Featured Blogs")
        })
    },
    watch: {
        blog: function(data) {
            // No "Featured Blogs" category in this language: show nothing rather than crash.
            if (!data || !data.posts || !data.posts.length) {
                this.mainPost = null;
                this.posts = [];
                return;
            }
            this.mainPost = first(data.posts);
            this.posts = filter(
                data.posts,
                item => item.ID !== this.mainPost.ID
            );
        }
    }
};
</script>
